/* import __COLOCATED_TEMPLATE__ from './schedules.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type OfficeHoursSchedule from 'embercom/models/office-hours-schedule';

interface Args {
  hideBorder?: boolean;
}

export default class StandaloneZendeskSchedules extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;

  get zendeskPlatform() {
    return this.finStandaloneService.zendeskPlatform;
  }

  get isLoadingZendeskSchedules() {
    return this.zendeskPlatform.isLoadingZendeskSchedules;
  }

  get zendeskConfig() {
    return this.zendeskPlatform.zendeskConfig;
  }

  get zendeskSchedules(): Array<OfficeHoursSchedule> {
    return this.zendeskPlatform.zendeskSchedules ?? [];
  }

  get zendeskScheduleCreationHref(): string | undefined {
    if (!this.zendeskConfig?.subdomain || this.zendeskConfig?.isPendingSetupForTickets) {
      return undefined;
    }

    return `${this.zendeskConfig.adminBaseUrl}/objects-rules/rules/schedules`;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Settings::Schedules': typeof StandaloneZendeskSchedules;
    'standalone/zendesk/settings/schedules': typeof StandaloneZendeskSchedules;
  }
}
